module.exports = __webpack_public_path__ + "static/front-008-a5e8b88e5e4c32a6e9cf41857ab449e6.png";